import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function ProductPresentation() {
  return <section className="py-6 md:py-24 px-4 bg-white overflow-hidden relative" data-id="element-145">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-celeste/10 rounded-full blur-[150px] pointer-events-none" data-id="element-146"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-147">
        {/* Ebook Mockup */}
        <FadeIn data-id="element-148">
          <div className="flex justify-center mb-4 md:mb-8" data-id="element-149">
            <img src="https://cdn.magicpatterns.com/uploads/5gVTX73er7jP5zSKKvsLuy/chau_vape_ebook_3.png" alt="CHAU VAPE - Ebook para dejar el vape en 30 días" className="w-full md:w-full max-w-2xl rounded-2xl shadow-[0_20px_60px_rgba(14,165,233,0.2)]" data-id="element-150" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-151">
          <div className="inline-block mb-2 md:mb-6" data-id="element-152">
            <h2 className="font-display font-black text-4xl md:text-6xl text-gray-900 tracking-tight" data-id="element-153">
              <span className="text-celeste mr-2 md:mr-4" data-id="element-154">📘</span>CHAU VAPE: La
              guía definitiva.
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-155">
          <p className="text-xl md:text-3xl text-gray-700 font-medium mb-6 md:mb-10 max-w-2xl mx-auto leading-tight" data-id="element-156">
            Un plan de 30 días estructurado para Argentina. Sin vueltas. Directo
            al punto.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} className="flex flex-col items-center space-y-6 md:space-y-8" data-id="element-157">
          <motion.a href="https://brandersecomm.myshopify.com/cart/add?id=50694869188855&quantity=1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto bg-celeste text-white font-display font-black text-lg md:text-2xl py-5 px-10 rounded-xl text-center uppercase tracking-wide glow-celeste transition-all shadow-lg" data-id="element-158">
            👉 EMPEZAR MI PLAN DE 30 DÍAS
          </motion.a>

          <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-sm md:text-xl text-gray-600 font-medium" data-id="element-159">
            <span className="bg-gray-50 px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-gray-200" data-id="element-160">
              🇦🇷 Adaptada a Argentina
            </span>
            <span className="bg-gray-50 px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-gray-200" data-id="element-161">
              🚫 Sin humo
            </span>
            <span className="bg-gray-50 px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-gray-200" data-id="element-162">
              📚 Sin teoría
            </span>
            <span className="bg-gray-50 px-3 py-1.5 md:px-4 md:py-2 rounded-full border border-gray-200" data-id="element-163">
              🛑 Sin chamuyo
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}